import { AlertCircle } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { CardTitleProps } from './CardTitle.types';

import styles from './CardTitle.module.css';

const NewPatchGroup = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.newPatchGroup}>
      <AlertCircle size={24} />
      <span>{t('bundleUpcharges.newPatchGroup')}</span>
    </div>
  );
};

const Title = ({ title }: CardTitleProps) => <h1 className={styles.cardTitle}>{title}</h1>;

export const CardTitle = ({ title }: CardTitleProps) => {
  const TitleComponent = title ? <Title title={title} /> : <NewPatchGroup />;

  return TitleComponent;
};
